import { useOkapiKy } from "@folio/stripes/core";
import { fetchTitleById } from "../api/titleService";
import { fetchPeriodicalTitleById } from "../api/periodicalLibraryService";
import { useDetailEntity } from "./useDetailEntity";
export var useTitleActions = function (titleType) {
    if (titleType === void 0) { titleType = "MONOGRAPH"; }
    var ky = useOkapiKy();
    // The periodicals-only librarian role lacks legal-deposits.titles.item.get
    var _a = useDetailEntity("title-detail", function (id) {
        return titleType === "PERIODICAL"
            ? fetchPeriodicalTitleById(ky, id)
            : fetchTitleById(ky, id);
    }), selectedItem = _a.selectedItem, handleRowClick = _a.handleRowClick, handleCloseDetail = _a.handleCloseDetail;
    return {
        selectedTitle: selectedItem,
        handleRowClick: function (id) { return handleRowClick(id); },
        handleCloseDetail: handleCloseDetail,
    };
};
